import { Platform, View, StyleSheet } from 'react-native';
import { logger } from '@/src/core/utils';
import { useSubscription } from '@/src/context/SubscriptionContext';
import env from '@/src/core/config/env';
import { AdBannerWeb } from './AdBannerWeb';

export interface AdBannerProps {
  colors: { background: string; border: string };
}

// Conditionally import to avoid web/Expo Go crashes
let BannerAd: any;
let BannerAdSize: any;
let TestIds: any;
if (Platform.OS !== 'web') {
  try {
    const ads = require('react-native-google-mobile-ads');
    BannerAd = ads.BannerAd;
    BannerAdSize = ads.BannerAdSize;
    TestIds = ads.TestIds;
  } catch {
    // Native module not available (e.g., Expo Go)
  }
}

export const AdBanner = ({ colors }: AdBannerProps) => {
  const { isPro } = useSubscription();

  if (Platform.OS === 'web') return <AdBannerWeb colors={colors} />;
  if (!BannerAd || isPro) return null;

  const adUnitId =
    Platform.OS === 'ios'
      ? env.admobBannerIdIos || TestIds.ADAPTIVE_BANNER
      : env.admobBannerIdAndroid || TestIds.ADAPTIVE_BANNER;

  return (
    <View style={[styles.container, { backgroundColor: colors.background, borderColor: colors.border }]}>
      <BannerAd
        unitId={adUnitId}
        size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
        onAdLoaded={() => logger.debug('AdMob', 'Banner loaded')}
        onAdFailedToLoad={(error: any) =>
          logger.warn('AdMob', 'Banner failed to load', { error: String(error) })
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginVertical: 8,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderBottomWidth: StyleSheet.hairlineWidth,
    paddingVertical: 4,
  },
});
